import type { SVGProps } from 'react';

interface SidebarIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export function SidebarIcon({ className, ...props }: SidebarIconProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="5 5 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <rect x="18.25" y="17.25" width="12.5" height="10.5" rx="2.25" transform="rotate(-180 18.25 17.25)" stroke="currentColor" strokeWidth="1.5"/><path d="M9.42072 17L9.42072 5.99999" stroke="currentColor" strokeWidth="1.5"/>
    </svg>
  );
}
